module.exports = __webpack_public_path__ + "img/green_085.bd9a1a28.png";